import FieldTypesEnum from '../Enums/FieldTypesEnum';
import dateTimeHelper from '../Helpers/datetimeHelper';

export default class ExchangeRateItem {
  constructor(item) {
    if (!item) {
      this.ExchangeRateId = '';
      this.UtctimeStamp = '';
      this.Rate = '';
      this.InverseRate = '';
      this.type = '';
      return;
    }
    this.ExchangeRateId = item.exchangeRateId;
    this.UtctimeStamp = item.utctimeStamp;
    this.Rate = item.rate;
    this.InverseRate = item.inverseRate;
    this.Type = item.type;
  }

  static NameOfTheIdField() {
    return 'ExchangeRateId';
  }

  static nameOfTheItemDetailList() {
    return 'Exchange Rate';
  }

  static MoneyFields = [];

  static Currency() {}

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {}

  static DateFields = [];

  static BoolFields = [];
  static FieldsToShowInListTable = [];

  static generateDateFieldContent(item) {
    if (item.Type === 'Daily') return dateTimeHelper.toYYYYsMMsDDWithIndefinite(item.UtctimeStamp);
    if (item.Type === 'Monthly') return dateTimeHelper.toYYYYsMM(item.UtctimeStamp, '-');
    return null;
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'UTC - Time Stamp',
        orderById: 'UtctimeStamp',
        data: ExchangeRateItem.generateDateFieldContent,
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Rate',
        orderById: 'Rate',
        data: 'Rate',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Inverse Rate',
        orderById: 'InverseRate',
        data: 'InverseRate',
        type: FieldTypesEnum.PureDataField,
      },
    ];
  }
}
